import { getCookie } from 'cookies-next/client'
import { authCookieName } from './setAuthCookie'
import { logError } from '../log'

export const getAuthCookie = (): string | null => {
  try {
    const cookie = getCookie(authCookieName)

    return cookie || null
  } catch (error) {
    logError('Error accessing auth cookie:', error)
    return null
  }
}
